<template>
	<core-modal
		:name="campaign.id + '-preview-modal'"
		class="omapi-modal preview-modal"
		:headerText="campaign.name"
		:width="700"
	>
		<modals-content>
			<campaigns-screenshots :campaign="campaign" />
		</modals-content>

        <footer class="footer">
            <section class="campaign-meta">
                <div class="campaign-meta__item">
                    <span class="campaign-meta__key">Campaign ID:</span>
                    <span class="campaign-meta__value">{{ this.campaign.id }}</span>
                </div>

                <div class="campaign-meta__item">
                    <span class="campaign-meta__key">Last edited on:</span>
                    <span class="campaign-meta__value"><time>{{ this.formattedDate }}</time></span>
                </div>
            </section>
        </footer>
	</core-modal>
</template>

<script>
import moment from 'moment'

export default {
	props : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		formattedDate () {
			return moment(this.campaign.updated).format('LLLL')
		},
	},
}
</script>

<style lang="scss">
@import '../../../assets/scss/variables';

.omapi-modal.preview-modal .campaign-meta {
    font-weight: 400;
    text-align: center;

	.campaign-meta__item {
        font-size: .75rem;

        .campaign-meta__key {
            color: $font_secondary-color;
            margin-right: 5px;
        }

        .campaign-meta__value {
            color: $color_black;
        }
	}
}

body .v--modal-overlay.preview-modal .v--modal {
	border-radius: 0;

	.header {
		background-color: $color_white-button-background!important;
		color: $color_black!important;
		text-align: center;
		display: block!important;

		.close {
			position: absolute;
			right: 20px;
			top: 0;
			height: 55px;
			max-height: none!important;
			color: $font_secondary-color!important;
		}
	}

	.content {

		.screenshot {
			margin: 0;
		}

		.toggle {
			border-color: $color_grey-border;
			color: $font_dark-color;
			font-size: 13px;

			&.active,
			&:hover,
			&:focus,
			&:active {
				border-color: $color_blue-primary;
				color: $color_white;
			}
		}
	}

	.footer {
		font-size: 13px;
		line-height: 1.5;
		padding: 0 20px 20px;
	}
}
</style>
